import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button, Badge } from "react-bootstrap";

import sweapLogo from "./../img/sweap-logo.svg";
import UserAuthService from "../services/UserAuthService";
import ApiService from "../services/ApiService";
import { useTrialMode } from "../hooks/useTrialMode";
import TrialModeModal from "./modals/TrialModeModal";

interface NavigationProps {
    authService: UserAuthService;
    apiService: ApiService;
}

const Navigation: React.FC<NavigationProps> = (props) => {
    const { t } = useTranslation("common");
    const { authService, apiService } = props;
    const [isLoggendIn, setLoggendIn] = useState(authService.isLoggedIn());
    const [showTrialModal, setShowTrialModal] = useState(false);
    const { isTrialMode } = useTrialMode(apiService, authService);

    authService.onAuthStateChanged((user) => {
        setLoggendIn(user !== undefined);
    });

    const handleLogout = (event: React.MouseEvent<HTMLButtonElement>) => {
        authService.logout();
    };

    const user = authService.getUser();

    return (
        <Navbar variant="tabs" expand="lg" className="bg-body-tertiary app-nav">
            <Container>
                <Navbar.Brand href="https://www.sweap.io">
                    <img alt="Sweap" src={sweapLogo} className="d-inline-block align-top sweap-logo" />
                </Navbar.Brand>
                <Navbar.Brand href="/">{t("base.title")}</Navbar.Brand>
                {isTrialMode && (
                    <Navbar.Brand>
                        <Badge
                            bg="warning"
                            text="dark"
                            role="button"
                            className="cursor-pointer"
                            onClick={() => setShowTrialModal(true)}
                            title={t("trialMode.title")}
                        >
                            {t("trialMode.badge")}
                        </Badge>
                    </Navbar.Brand>
                )}

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    {isLoggendIn === true ? (
                        <>
                            <Nav className="me-auto">
                                <NavLink className="nav-link" to="/">
                                    {t("navigation.home")}
                                </NavLink>
                                <NavLink className="nav-link" to="/documents">
                                    {t("navigation.documents")}
                                </NavLink>
                                <NavLink className="nav-link" to="/templates">
                                    {t("navigation.templates")}
                                </NavLink>
                            </Nav>
                            <div className="d-flex align-items-center">
                                <span className="navbar-text me-3">
                                    {t("navigation.welcome", { username: user?.username || "User" })}
                                </span>
                                <Button variant="outline-danger" size="sm" onClick={handleLogout}>
                                    {t("navigation.logout")}
                                </Button>
                            </div>
                        </>
                    ) : (
                        <Nav className="me-auto">
                            <NavLink className="nav-link" to="/login">
                                {t("navigation.login")}
                            </NavLink>
                        </Nav>
                    )}
                </Navbar.Collapse>
            </Container>

            <TrialModeModal show={showTrialModal} onHide={() => setShowTrialModal(false)} />
        </Navbar>
    );
};

/*
<NavDropdown title="Dropdown" id="basic-nav-dropdown">
          <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
          <NavDropdown.Item href="#action/3.2">
            Another action
          </NavDropdown.Item>
          <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item>
        </NavDropdown>
        */
export default Navigation;
